// extracted by mini-css-extract-plugin
module.exports = {"item":"ItemInShop_item__ICfvt","btn":"ItemInShop_btn__3FS15","image":"ItemInShop_image__3RlHl"};